var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 2.16004C12.7126 2.05676 12.5589 2 12.4 2C12.2411 2 12.0874 2.05676 11.9667 2.16004L2.40002 10.36V20C2.40002 20.5304 2.61074 21.0391 2.98581 21.4142C3.36088 21.7893 3.86959 22 4.40002 22H9.73334C9.91015 22 10.0797 21.9298 10.2047 21.8047C10.3298 21.6797 10.4 21.5101 10.4 21.3333V17.3333C10.4 16.8029 10.6107 16.2942 10.9858 15.9191C11.3609 15.5441 11.8696 15.3333 12.4 15.3333C12.9304 15.3333 13.4391 15.5441 13.8142 15.9191C14.1893 16.2942 14.4 16.8029 14.4 17.3333V21.3333C14.4 21.5101 14.4702 21.6797 14.5953 21.8047C14.7203 21.9298 14.8899 22 15.0667 22H20.4C20.9304 22 21.4391 21.7893 21.8142 21.4142C22.1893 21.0391 22.4 20.5304 22.4 20V10.36L12.8333 2.16004Z",
    fill: "#C2C2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon_home.abb3fbb8159e2d02577be355617aa0a2.svg";
export { ForwardRef as ReactComponent };